import { useEffect, useRef } from 'react'
import type { MapCoordinate } from 'tripPlanner/utils/mapMarkerTransforms'
import type { ExploreHandoffSearch } from './useChatMapExploreFilters'

interface Args {
  exploreHandoff: ExploreHandoffSearch | undefined
  exploreMarkers: ReadonlyArray<MapCoordinate>
  fitToCoordinates: (coordinates: Array<MapCoordinate>) => void
}

/**
 * Frames a handed-over search on its own results. The camera move that opened the map is drawn
 * before the search answers, so it cannot know whether the stop's things to do sit in one street
 * or along half a coastline. Fits once per handoff, leaving later panning alone.
 */
export function useExploreHandoffCamera({
  exploreHandoff,
  exploreMarkers,
  fitToCoordinates,
}: Args): void {
  const fittedHandoffRef = useRef<ExploreHandoffSearch | undefined>(undefined)

  useEffect(() => {
    if (!exploreHandoff) {
      fittedHandoffRef.current = undefined
      return
    }
    if (fittedHandoffRef.current === exploreHandoff || exploreMarkers.length === 0) return

    fittedHandoffRef.current = exploreHandoff
    fitToCoordinates([...exploreMarkers])
  }, [exploreHandoff, exploreMarkers, fitToCoordinates])
}
